import { useBetween } from "use-between";
import { useSelector } from "react-redux";
import { useState } from "react";

const useConfirmCode = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedState));
  const [code, setCode] = useState("");

  const backToSignUp = () => {
    document.querySelector(".Signup").classList.toggle("current-section-start");
    document
      .querySelector(".copy-rights-section")
      .classList.remove("current-section-start");
    document
      .querySelector(".ConfirmCode")
      .classList.remove("current-section-start");
  };

  const onChangeInput = (event) => {
    document
      .getElementById("confirm-signup-code")
      .classList.remove("is-invalid");
    setCode(event.target.value);
  };
  const checkInput = () => {
    if (code === "")
      document
        .getElementById("confirm-signup-code")
        .classList.add("is-invalid");
  };
  return {
    locale,
    backToSignUp,
    onChangeInput,
    checkInput,
  };
};

export default useConfirmCode;
